module.exports = __webpack_public_path__ + "static/media/15.05bacc93.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/lhand/15.png
// module id = 755
// module chunks = 0